<template>
  <fragment>
    <div>
      <div v-if="!loading" class="row">
        <div class="col-12">
          <b-carousel v-if="feeds && feeds.length" id="home_feed_carousel"
                      ref="homepageFeedCarousel"
                      v-model="slide"
                      :interval="0">
            <b-carousel-slide v-for="(feed_chunk, index) in feed_chunks" :key="`feed_chunk_${index}`" class="row-slide">
              <template #img>
                <div class="row">
                  <div v-for="feed in feed_chunk"
                       :key="feed.uuid"
                       class="mb-2"
                       :class="feed_col_classes">
                    <div class="card">
                      <img class="img-fluid card-img" :src="feed.feed_artwork_thumbnail_url" alt="Feed Thumbnail">
                      <div class="card-img-overlay d-none">
                        <div class="my-auto mx-auto text-center">
                          <h4>{{ feed.name }}</h4>
                          <a :href="`/feeds/${feed.uuid}/edit`" class="btn btn-ss-standout btn-icon mb-2">
                            <i class="fa fa-edit" />
                          </a>
                          <a :href="feed.feed_xml_file_url" target="_blank" class="btn btn-ss btn-icon mb-2">
                            <i class="fa fa-rss" />
                          </a>
                          <button class="btn btn-ss btn-icon mb-2" @click="() => initSocialShareModal(feed)">
                            <i class="fa fa-share-alt" />
                          </button>

                          <button class="btn btn-ss btn-icon mb-2" @click="() => initPreviewFeedModal(feed)">
                            <i class="fa fa-play" />
                          </button>
                          <br>
                          <button class="btn btn-ss mb-2" @click="initQuickCreateModal(feed)">
                            + Add Item
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </b-carousel-slide>
          </b-carousel>
        </div>
      </div>
      <div v-if="!loading && feed_chunks && feed_chunks.length > 1" class="row mt-3">
        <div class="col-12 text-center">
          <button class="btn btn-ss btn-sm" @click="previousSlide">
            &LT; Prev
          </button>
          <button class="btn btn-ss btn-sm" @click="nextSlide">
            Next &GT;
          </button>
        </div>
      </div>
      <loader v-if="loading" loading-text="Loading Feeds ..." />
    </div>

    <div>
      <vjs-modal name="form_grid_item_create_modal"
                 :title="`Create ${getItemLabel(true)}`"
                 icon="la la-plus-circle">
        <item-creation-form :preselected-feed="clicked_feed" />
      </vjs-modal>
      <!-- couldn't get this to work -->
      <social-share-modal id="share-feed-confirm" name="share-feed" :entity="clicked_feed" />
      <preview-modal name="preview-feed" :is-feed="true" :entity="clicked_feed" />
    </div>
  </fragment>
</template>

<script>

import ItemCreationForm from "VueComponents/ItemCreation/Form";
import { BCarousel } from 'bootstrap-vue';
import SocialShareModal from 'VueModals/SocialShareModal';
import PreviewModal from "VueModals/PreviewModal";
import Loader from "VuePartials/Loader";
Vue.component('b-carousel', BCarousel);

export default {
  components: {
    Loader,
    PreviewModal,
    SocialShareModal,
    ItemCreationForm,
  },
  props: {
    feedsPerChunk: {
      type: Number,
      required: false,
      default: 6,
    },
    large: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      feeds: [],
      slide: 0,
      clicked_feed: {},
      loading: true,
    };
  },
  computed: {
    feed_chunks() {
      return this.feeds && this.feeds.length ? _.chunk(this.feeds, this.feedsPerChunk) : [];
    },
    feed_col_classes() {
      return this.large ? 'col-3' : 'col-12 col-md-6 col-lg-4';
    },
  },
  watch: {
    feed_chunks() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.equaliseRowHeights();
        }, 2000);
      });
    },
  },
  mounted() {
    this.getFeeds();
  },
  methods: {
    initSocialShareModal(feed) {
      this.clicked_feed = feed;
      this.$nextTick(() => {
        this.fireModal(`share-feed`);
      });
    },
    initQuickCreateModal(feed) {
      // Re-init the component and show the modal
      this.clicked_feed = null;
      this.$nextTick(() => {
        this.clicked_feed = feed;
        this.fireModal(`form_grid_item_create_modal`);
      });
    },
    initPreviewFeedModal(feed) {
      this.clicked_feed = null;
      this.$nextTick(() => {
        this.clicked_feed = feed;
        this.fireModal(`preview-feed`);
      });
    },
    async getFeeds() {
      try {
        const response = await axios.get('/api/v1/feeds?with_player_data=true');
        this.feeds = response.data.data;
        this.loading = false;
      } catch (error) {
        console.error(error);
        this.handleAxiosError(error);
        this.loading = false;
      }
    },
    equaliseRowHeights() {
      const heights = [];
      const selector = $('.row-slide');

      selector.each(function () {
        const height = $(this).height();
        heights.push(height);
      });

      const max_height = Math.max.apply(null, heights);

      selector.each(function () {
        $(this).height(max_height);
      });
    },
    nextSlide() {
      this.$refs.homepageFeedCarousel.next();
    },
    previousSlide() {
      this.$refs.homepageFeedCarousel.prev();
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  max-width: 28rem;
  .card-img-overlay {
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
  }
  &:hover {
    .card-img-overlay {
      display:flex !important;
    }
  }
}
</style>
